import { render } from "./SubmissionConfirmationCampaignList.vue?vue&type=template&id=0ba27682&scoped=true"
import script from "./SubmissionConfirmationCampaignList.vue?vue&type=script&lang=js"
export * from "./SubmissionConfirmationCampaignList.vue?vue&type=script&lang=js"

import "./SubmissionConfirmationCampaignList.vue?vue&type=style&index=0&id=0ba27682&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba27682"],['__file',"src/components/SubmissionConfirmationCampaignList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ba27682"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ba27682', __exports__)) {
    api.reload('0ba27682', __exports__)
  }
  
  module.hot.accept("./SubmissionConfirmationCampaignList.vue?vue&type=template&id=0ba27682&scoped=true", () => {
    api.rerender('0ba27682', render)
  })

}


export default __exports__